export default __webpack_public_path__ + "static/media/Head_1_Ear_3_C3.b7b58e43.svg";